var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extends"},[_c('Label',_vm._b({},'Label',_vm.__labelProps,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }